<template>
  <div class="ym-pc-contact-info">
    <div class="modal-list">
      <div class="contact-phone-modal contact-modal"
           v-if="currIndex === 0"
      >
        <div>免费拨打<span class="phone">{{ consumerHotLine }}</span></div>
        <div class="date">{{ serviceTime }}</div>
      </div>
      <div class="contact-wechat-modal contact-modal"
           v-if="currIndex === 1"
      >
        <div class="contact-tip">扫码添加 马上咨询</div>
        <div class="contact-qr-code">
          <img :src="wxPath"
               alt="微信咨询"
          >
        </div>
      </div>
      <div class="contact-mini-modal contact-modal"
           :class="{ active: wxPath!== '' }"
           v-if="currIndex === 2"
      >
        <div class="contact-tip">扫码添加 马上咨询</div>
        <div class="contact-qr-code">
          <img :src="miniPath"
               alt="微信咨询"
          >
        </div>
      </div>
    </div>
    <div class="icon-list">
      <div class="contact-item"
           :style="itemBgStyle"
           @mouseenter="handleModalItem('enter', 0)"
           @mouseleave="handleModalItem('leave', 0)"
      >
        <img :src="require('@/assets/img/default/contact_phone.png')"
             alt="电话咨询"
        />
        <span class="desc">电话咨询</span>
      </div>
      <div class="contact-item"
           :style="itemBgStyle"
           @mouseenter="handleModalItem('enter', 1)"
           @mouseleave="handleModalItem('leave', 1)"
           v-if="wxPath !== ''"
      >
        <img :src="require('@/assets/img/default/contact_wechat.png')"
             alt="微信咨询"
        >
        <span class="desc">微信咨询</span>
      </div>
      <div class="contact-item"
           :style="itemBgStyle"
           @mouseenter="handleModalItem('enter', 2)"
           @mouseleave="handleModalItem('leave', 2)"
           v-if="miniPath !== ''"
      >
        <img :src="require('@/assets/img/default/contact_mini.png')"
             alt="在线客服"
        >
        <span class="desc">在线客服</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { CONSUMER_HOTLINE } from '@/utils/constant';

  export default {
    name: 'YmPcContactInfo',
    props: {
      serviceTime: {
        type: String,
        default: '周一至周六 9:00-18:00',
      },
      wxPath: {
        type: String,
        default: '',
      },
      miniPath: {
        type: String,
        default: '',
      },
      topColor: {
        type: String,
        default: '',
      },
      bottomColor: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        currIndex: -1,
      };
    },
    computed: {
      consumerHotLine() {
        return CONSUMER_HOTLINE;
      },
      itemBgStyle() {
        const result = {};
        const value = `linear-gradient(to bottom, ${this.topColor}, ${this.bottomColor})`;
        result.background = this.topColor && this.bottom ? value : '#12c8bf';
        if (this.itemColor) {
          result.color = this.itemColor;
        }
        return result;
      },
    },
    methods: {
      handleModalItem(type, index) {
        if (type === 'enter') {
          this.currIndex = index;
        }
        if (type === 'leave') {
          this.currIndex = -1;
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-pc-contact-info {
    position: fixed;
    top: 20%;
    right: 100px;
    z-index: 1000;
    display: flex;
  }

  .icon-list {
    margin-left: @size-small;
  }

  .contact-item {
    width: 70px;
    height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    .desc {
      line-height: 1;
      font-size: 14px;
      color: @color-white;
      margin-top: @size-extra-small / 2;
    }
    &:not(:last-child) {
      margin-bottom: @size-extra-small;
    }
    &:nth-child(1) {
      img {
        display: block;
        width: 30px;
        height: 32px;
      }
    }
    &:nth-child(2) {
      img {
        display: block;
        width: 40px;
        height: 36px;
      }
    }
    &:nth-child(3) {
      img {
        display: block;
        width: 40px;
        height: 40px;
      }
    }
  }

  .contact-phone-modal {
    padding: 10px 15px;
    border-radius: 10px;
    border: 1px solid #12c8bf;
    color: #222;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    background: #fff;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: 40%;
      right: -5px;
      width: 10px;
      height: 10px;
      border-radius: 0 3px 0 0;
      transform: rotate(45deg);
      background: #fff;
      border-top: 1px solid #12c8bf;
      border-right: 1px solid #12c8bf;
      border-bottom: none;
      border-left: none;
    }
    .phone {
      color: #12c8bf;
      font-size: 18px;
      margin-left: 5px;
    }
    .date {
      font-weight: 400;
      color: #666;
      font-size: 14px;
    }
  }

  .contact-modal {
    img {
      display: block;
      width: 120px;
      height: 120px;
    }
  }

  .contact-wechat-modal,
  .contact-mini-modal {
    padding: 25px;
    border-radius: 10px;
    border: 1px solid #12c8bf;
    background: #fff;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: 30px;
      right: -5px;
      width: 10px;
      height: 10px;
      border-radius: 0 3px 0 0;
      transform: rotate(45deg);
      background: #fff;
      border-top: 1px solid #12c8bf;
      border-right: 1px solid #12c8bf;
      border-bottom: none;
      border-left: none;
    }
    .contact-tip {
      padding: 4px 24px;
      background: linear-gradient(270deg,rgba(0,191,208,1) 0%,rgba(68,222,216,1) 100%);
      border-radius: 30px;
      box-sizing: border-box;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      position: relative;
      z-index: 2;
      &:after {
        content: '';
        position: absolute;
        z-index: 1;
        left: 48%;
        bottom: -4px;
        width: 10px;
        height: 10px;
        border-radius: 2px;
        transform: rotate(45deg);
        background: #22ced4;
      }
    }
    .contact-qr-code {
      width: 120px;
      height: 120px;
      border: 1px solid #eee;
      margin: 20px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .contact-wechat-modal {
    margin-top: 80px;
  }

  .contact-mini-modal {
    margin-top: 80px;
    &.active {
      margin-top: 160px;
    }
  }

</style>
